export const mainSiteUrl = 'https://kaspreadsheet.com';
export const mainSiteName = 'kaspreadsheet.com';